
import { useCallback } from "react";
import { ContentItem } from "../types";

import { useContentLoader } from "./useContentLoader";
import { useContentPagination } from "./useContentPagination";
import { useContentUpdate } from "./useContentUpdate";
import { useContentCreation } from "./useContentCreation";

export function useContentManagement() {
  const { allContent, setAllContent, isLoading } = useContentLoader();
  
  const { 
    pagination, 
    getPaginatedContent, 
    handlePageChange, 
    updateTotalItems 
  } = useContentPagination(allContent);
  
  const { 
    handleChangeContentCredits, 
    handleTogglePremiereStatus, 
    handleToggleContentVisibility,
    handleDeleteContent
  } = useContentUpdate(allContent, setAllContent);
  
  // Callback for when new content is added
  const handleContentAdded = useCallback((newItem: ContentItem) => {
    setAllContent(prev => [...prev, newItem]);
    updateTotalItems(allContent.length + 1);
  }, [allContent, setAllContent, updateTotalItems]);
  
  const { 
    newContent, 
    submissionState, 
    handleAddContent, 
    handleFileChange, 
    handleThumbnailChange, 
    handleContentChange 
  } = useContentCreation(handleContentAdded);

  // Get the content for the current page
  const content = getPaginatedContent();

  return {
    content,
    isLoading,
    newContent,
    submissionState,
    pagination,
    handleChangeContentCredits,
    handleTogglePremiereStatus,
    handleToggleContentVisibility,
    handleDeleteContent,
    handleAddContent,
    handleFileChange,
    handleThumbnailChange,
    handleContentChange,
    handlePageChange
  };
}
